import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import * as moment from "moment";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { Observable } from "rxjs/Observable";

import { ExamineeRequestService } from "../../request/examinee/examinee-request.service";
import { AppService } from "../../services/app.service";
import { LoggerService } from "../../services/audit-logger.service";
import { CommonService } from "../../services/common.service";
import { ExportToCSVService } from "../../services/exporttocsv.service";
import { TestService } from "../../services/test.service";
import { User } from "../../services/user.model";
import { ExamineeModel, StudentDetails } from "../examinee.model";
import { ExamineesService } from "../examinees.service";
import { TestFilterModel } from "../test-filter.model";

declare var jQuery: any;
declare var _: any;
@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.css"]
})
export class ListComponent implements OnInit, AfterViewInit {
  @ViewChild("lgModal") lgModal: ElementRef;
  public examineeForm: FormGroup;
  public listExamineesData: ExamineeModel[] = [];
  public filteredData: ExamineeModel[] = [];
  public testData: Map<string, TestFilterModel>;
  public get testFilters(): TestFilterModel[] {
    if (!this.testData) {
      return [];
    }
    return Array.from(this.testData.values());
  }
  public dynamicContent: any;
  public tacInfo: string;
  public certification1: string;
  public certification2: string;
  public trainingLink: string;
  public lateConsiderationUrl: string;
  public personId: any;
  public testDateId: any;
  public testDateNm: any;
  public tests: any;
  public testDates: any;
  public userProfile: User;
  public sortingLabel: string = '';

  testTableData: any = [];
  matchingTestDateIdsWithPersonId: any = [];
  modalApplyBtnDisabled: boolean = true;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  show: any = { advancedSearch: false };

  constructor(
    private _examineesService: ExamineesService,
    private exportCsvService: ExportToCSVService,
    private _commonService: CommonService,
    private modalService: BsModalService,
    private _loggerService: LoggerService,
    private testService: TestService,
    private examineeRequestService: ExamineeRequestService,
    private appService: AppService
  ) {
    this.searchExamineeResults({});
    this.testService.getTest().subscribe(tests => {
      this.tests = tests;
    });
  }

  ngOnInit() {
    this.examineeRequestService.currentRequest = null;
    sessionStorage.removeItem("currentStudent");
    sessionStorage.removeItem("selectedStudent");
    Observable.forkJoin(
      this._commonService.getDynContent("TAC_INFO_MSG"),
      this._commonService.getDynContent("SPECIAL_TESTING_CERTIFICATION_ONE"),
      this._commonService.getDynContent("SPECIAL_TESTING_CERTIFICATION_TWO"),
      this._commonService.getDynContent("NEW_REQUEST_TRAINING_LINK"),
      this._commonService.getDynContent("LATE_CONSIDERATION_URL")
    ).subscribe(([tacInfo, certification1, certification2, trainingLink, lateConsiderationUrl]) => {
      this.tacInfo = tacInfo;
      this.certification1 = certification1;
      this.certification2 = certification2;
      this.trainingLink = trainingLink;
      this.lateConsiderationUrl = lateConsiderationUrl;
    });
    this.listExamineesData = new Array<any>();
    this.examineeForm = new FormGroup({
      taaPin: new FormControl(),
      lastName: new FormControl(),
      firstName: new FormControl(),
      test: new FormControl(),
      taName: new FormControl(),
      fromDate: new FormControl(),
      toDate: new FormControl()
    });
    this.appService.getUserProfile().then(user => (this.userProfile = user));
  }
//sort order for screen reader
  sortOrder: { [key: string]: 'none' | 'ascending' | 'descending' } = {
    taaPin: 'none', test: 'none', lastName: 'none', firstName: 'none', middleInitial: 'none', status: 'none', 
    certification: 'none', submittedDate: 'none', submittedBy: 'none'
  };

  sort(column: string) {
    if (this.sortOrder[column] === 'none' || this.sortOrder[column] === 'descending') {
      this.sortOrder[column] = 'ascending';
      this.sortingLabel = `Sorted by ${column} in ascending order`;
    } else {
      this.sortOrder[column] = 'descending';
      this.sortingLabel = `Sorted by ${column} in descending order`;
    }
    // Reset other columns' sort order
    for (const key in this.sortOrder) {
      if (key !== column) {
        this.sortOrder[key] = 'none';
      }
    }
  }

  sendStudentDetails(examinee: ExamineeModel) {
    const studentDetails: StudentDetails = {
      studentId: examinee.studentId,
      actId: examinee.actId,
      lastName: examinee.lastName,
      firstName: examinee.firstName,
      personId: examinee.personId,
      middleName: examinee.middleName,
      taaPin: examinee.taaPin,
      requestId: examinee.requestId
    };
    sessionStorage.setItem("selectedStudent", JSON.stringify(studentDetails));
    this._commonService.sendStudentDetails(studentDetails);
  }

  ngAfterViewInit() { }

  ngAfterViewChecked() {
      jQuery('.clickableHeader a').attr('tabindex', 0);
      jQuery('.clickableHeader a').each(function () {
        jQuery(this).attr('aria-label', 'Click to sort by ' + jQuery(this).parent().attr('by'));
      });
      jQuery('.clickableHeader a').on('keydown', function (evt) { 
        if (evt.keyCode === 13 || evt.keyCode === 32) {
          evt.target.click();
          evt.stopPropagation();
          evt.preventDefault();
        }
        return !(evt.key == ' ' && evt.target == document.body);
      });
  }

  changeTest(event) {
    const test = this.examineeForm.controls["test"].value;
    this.testDates = [];
    if (test) {
      this.testService
        .getDates(test.TEST_ID)
        .map((res: any) => {
          return res.body;
        })
        .subscribe(testDates => {
          this.testDates = testDates;
        });
    }
  }

  certificationClicked(examinee) {
    this.personId = examinee.personId;
    this._examineesService
      .getPersonTable(examinee.personId)
      .subscribe(response => {
        this.matchingTestDateIdsWithPersonId = _.filter(response, data => {
          return (
            data.PERSON_ID === examinee.personId &&
            _.toLower(data.PERSON_TEST_TYPE) === "special"
          );
        });
        const testDateIds = _.map(
          this.matchingTestDateIdsWithPersonId,
          "TEST_DATE_ID"
        );
        this.testDateId = _.uniq(testDateIds);
        this.testTableData = [];
        _.each(this.testDateId, dateId => {
          this._examineesService
            .getTestTable(dateId)
            .subscribe(testTableResponse => {
              this.testTableData = _.concat(
                this.testTableData,
                testTableResponse.body
              );
              if (this.testDateId.length === this.testTableData.length) {
                this.setTestTableData();
              }
            });
        });
      });
  }

  setTestTableData() {
    _.each(this.testTableData, data => {
      _.each(this.matchingTestDateIdsWithPersonId, item => {
        if (item.TEST_DATE_ID === data.TEST_DATE_ID) {
          data.person = item;
        }
      });
      data.Certification_Deadline = "";
      data.disabled = true;
      data.checked = false;

      if (moment().isAfter(moment(data.CERTIFY_CUT_OFF_DT))) {
        //past
        if (data.person.CERTIFIED_FL === "Y") {
          data.Certification_Deadline = "Please contact ACT to make changes";
          data.checked = true;
        } else {
          data.Certification_Deadline = "Deadline is passed.Please contact ACT";
        }
      } else if (moment().isBefore(moment(data.CERTIFY_CUT_OFF_DT))) {
        //future
        if (data.person.CERTIFIED_FL === "Y") {
          data.Certification_Deadline = "Please contact ACT to make changes";
          data.checked = true;
        } else {
          data.Certification_Deadline = this.extractFormattedDate(
            data.CERTIFY_CUT_OFF_DT
          );
          data.disabled = false;
        }
      }
      data.checkbox_state_changed = false;
      data.user =
        this.userProfile.givenName + " " + this.userProfile.familyName;
      data.SPL_TEST_ADMIN_START_DT = this.extractFormattedDate(
        data.SPL_TEST_ADMIN_START_DT
      );
      data.SPL_TEST_ADMIN_END_DT = this.extractFormattedDate(
        data.SPL_TEST_ADMIN_END_DT
      );
    });
    setTimeout(() => {
      this.modalApplyBtnDisabled = true;
      jQuery(this.lgModal.nativeElement)
        .find(".modal-dialog")
        .draggable({
          drag: event => {
            if (jQuery(event.toElement).closest(".modal-header").length) {
              return true;
            }
            event.preventDefault();
            event.stopPropagation();
          }
        });
      jQuery(this.lgModal.nativeElement)
        .find(".modal-dialog")
        .css("left", 0);
      setTimeout(() => {
        jQuery(this.lgModal.nativeElement).modal({
          show: true,
          backdrop: "static",
          keyboard: false
        });
      });
    });
  }

  extractFormattedDate(isoFormattedDate) {
    //This function is to extract only date irrespective of timezone format
    let formattedDate = "";
    formattedDate += moment.utc(isoFormattedDate).format("MMMM") + " ";
    formattedDate += moment.utc(isoFormattedDate).get("date") + ", ";
    formattedDate += moment.utc(isoFormattedDate).get("year");
    return formattedDate;
  }

  onLgModalClose() {
    const filterCheckBoxStateChangedRows = _.filter(
      this.testTableData,
      item => item.checkbox_state_changed
    );
    if (_.isEmpty(filterCheckBoxStateChangedRows)) {
      jQuery(this.lgModal.nativeElement).modal("hide");
      //  window.location.reload(); //reload the whole page
      this.filterResults(this.examineeForm.value); // reload only the table data
    }
    const stateChangedTestDateIDs = _.map(
      filterCheckBoxStateChangedRows,
      "TEST_DATE_ID"
    );
    const stateChangedTestDateNMs = _.map(
      filterCheckBoxStateChangedRows,
      "TEST_DATE_NM"
    );
    const filterMatchingTestDateIdsWithPersonId = _.filter(
      this.matchingTestDateIdsWithPersonId,
      item => _.indexOf(stateChangedTestDateIDs, item.TEST_DATE_ID) !== -1
    );
    if (_.isEmpty(filterMatchingTestDateIdsWithPersonId)) {
      alert("Error occured.Contact administrator");
      jQuery(this.lgModal.nativeElement).modal("hide");
      //  window.location.reload();
      this.filterResults(this.examineeForm.value);
    }
    let responseReceived = 0;
    _.each(filterMatchingTestDateIdsWithPersonId, (item, key) => {
      const data = {
        personId: this.personId,
        testId: item.TEST_DATE_ID,
        testNm: item.TEST_DATE_NM,
        certifiedBy:
          this.userProfile.givenName + " " + this.userProfile.familyName,
        updatedBy: this.userProfile.userName,
        certified_FL: "Y"
      };
      this._examineesService.updatePersonTest(data).subscribe(response => {
        responseReceived = responseReceived + 1;
        this.updateLogs(stateChangedTestDateNMs[key]);
        if (responseReceived === filterMatchingTestDateIdsWithPersonId.length) {
          jQuery(this.lgModal.nativeElement).modal("hide");
          this.filterResults(this.examineeForm.value);
        }
      });
    });
  }

  updateLogs(testDateNM) {
    const loggerModel = {
      MODULE_ID: "REQUEST",
      CATEGORY_ID: "CERTIFICATION",
      COMPONENT_ID: "CERTIFICATION POPUP",
      CREATED_BY_DS: this.userProfile.userName,
      MESSAGE_TX: "User certified test admin.",
      REFERENCE_ID: this.personId,
      SEVERITY_VAL: "",
      UPDATED_BY_DS: this.userProfile.userName,
      USER_DATA_VAL:
        " Certified " + testDateNM + " for examinee " + this.personId
    };
    this._loggerService.updateLog(loggerModel).subscribe(
      success => { },
      err => {
        console.log(err);
      }
    );
  }

  onModalCheckboxChange(modalRowData) {
    modalRowData.checkbox_state_changed = !modalRowData.checkbox_state_changed;
    this.modalApplyBtnDisabled = !modalRowData.checked;
  }

  filterResults(form) {
    this.searchExamineeResults({ filters: form });
  }

  searchExamineeResults(req: any) {
    this._examineesService.searchExaminees(req).subscribe(
      data => {
        this.listExamineesData = this.filteredData = data;
      },
      error => {
        console.log("Error while loading list examinees");
      }
    );
  }

  download(filteredData: ExamineeModel[]) {
    const personIds = this.filteredData.map(obj => obj.personId);
    this._examineesService.getExportData(personIds).subscribe(data => {
      this.exportCsvService.generateCSV(data.results);
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/examinees/list/list.component.ts